<template>
  <div id="app">
    <v-app id="inspire">
      <layout v-if="isLoggedIn && !isPrintLabels"></layout>
      <v-snackbar v-model="snackbar" :color="color"> {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false">{{ $t('message.common.close') }}</v-btn>
        </template>
      </v-snackbar>
      <v-main v-if="!isPrintLabels">
         <v-container fluid class="container--app">
           <router-view></router-view>
         </v-container>
      </v-main>
      <router-view v-else></router-view>
      <v-overlay :value="showFullLoader">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    </v-app>
  </div>
</template>

<script>
import Layout from './components/Layout'
import axios from 'axios'
export default {
  data () {
    return {
      text: '',
      snackbar: false,
      color: ''
    }
  },
  components: {
    Layout
  },
  computed: {
    isLoggedIn () {
      return this.$store.state.isLoggedIn
    },
    isPrintLabels () {
      return this.$route.name === 'print_labels'
    },
    showFullLoader () {
      return this.$store.getters.getShowFullLoader
    }
  },
  created () {
    const authToken = this.$cookie.get(process.env.VUE_APP_TOKEN)
    const user = this.$cookie.get(process.env.VUE_APP_USER) ? JSON.parse(this.$cookie.get(process.env.VUE_APP_USER)) : {}
    const authDetails = { authToken, user }
    if (authToken) this.$store.commit('authLogin', authDetails)
  },
  mounted () {
    this.$root.$on('snackbar', data => {
      this.snackbar = data.snackbar
      this.color = data.color
      this.text = data.text
    })
  },
  beforeMount () {
    const text = this.$t('message.login.authFailed')
    axios.interceptors.response.use(
      (response) => {
        return Promise.resolve(response)
      },
      (error) => {
        if (error.response) {
          let exception = error.response
          if (error.response.status === 409) {
            setTimeout(() => {
              window.location.reload()
            })
          } else {
            if (error.response.data) exception = `Status Code : ${error.response.status}, Message : ${error.response.data}`
            else exception = `Status Code : ${error.response.status}, Message : ${error.response.statusText}`
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(exception) })
            if (error.response.status === 401) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text })
              this.$store.dispatch('logout')
              this.$router.push('/login').catch(() => {})
            }
          }
        } else {
          const text = error.message
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(text) })
        }
        return Promise.reject(error)
      }
    )
  },
  destroyed () {
    this.$root.$off('snackbar')
  }
}
</script>
<style>
.v-list .v-list-item--active {
  color: #0c0c0c;
}
.dense_table .v-text-field--full-width input{
  margin-top: 0 !important;
}
.dense_table .v-text-field--full-width > .v-input__control > .v-input__slot {
  min-height: auto !important;
}
.dense_table .v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 3px !important;
}
.dense_table .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0 !important;
  font-size: 14px;
}
.dense_table.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: none !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  -webkit-box-shadow: inset 0px 5px 0px -5px rgba(50, 50, 50, 0.75), inset 0px 0px 8px -5px rgba(50, 50, 50, 0.75) !important;
  box-shadow: inset 0px 5px 0px -5px rgba(50, 50, 50, 0.75), inset 0px 0px 8px -5px rgba(50, 50, 50, 0.75) !important;
}
.bordered--table table, .bordered--table table thead tr, .bordered--table table tbody tr {
  border: 1px solid rgba(0,0,0,0.12);
}
.bordered--table table thead th, .bordered--table table tbody tr td, .bordered--table table tbody tr th {
  border-right: 1px solid rgba(0,0,0,0.12);
  border-bottom: 1px solid rgba(0,0,0,0.12);
}
.bordered--table table thead tr {
  height: 30px;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 0px !important;
}
.participants .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot, .participants .v-text-field--full-width > .v-input__control > .v-input__slot {
  padding: 0 !important;
  min-height: 0px !important;
}
.v-application {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif !important;
}
.no-preview .v-image__image--contain, .no-preview-layout {
  filter: grayscale(100%);
  opacity: 0.66;
}
.container--app {
  height: 100%;
}
.expansion--panel {
  background: #0c0c0c;
  color: white;
}
::-webkit-scrollbar-track {
  background-color: #ffffff;
  border-radius: 10px;
}
::-webkit-scrollbar {
  width: 3px;
  height: 2px;
  background-color: #ffffff;
}
::-webkit-scrollbar-thumb {
  background-color: #0c0c0c;
}
.compact--tree .v-treeview-node__root {
  margin: 0 !important;
}
.theme--light.v-input--is-disabled .v-label, .theme--light.v-select .v-select__selection--disabled, .theme--light.v-select.v-input--is-disabled .v-select__selections,  .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
  color: #000000bf !important;
}
.alignTop {
  vertical-align: top !important;
}
.alignSub {
  vertical-align: sub !important;
}
.v-data-table--dense td {
  height: 24px !important;
}
.production_order_history tbody td, .production_order_history thead tr, .production_order_history thead tr {
  height: 20px !important;
  padding: 0px !important;
}
.production_order_history {
  width: 100%;
  border-collapse: collapse;
}
.production_order_history thead th {
  color: rgba(0,0,0,.54);
}

.production_order_history thead tr, .production_order_history tbody tr:not(:last-child) {
  border-bottom: 1px solid rgba(0,0,0,.12);
}
/* data table select checkbox column width to 0 */
.select_checkbox_column_width_0 > div.v-data-table div.v-data-table__wrapper > table > thead th:first-child {
  width: 0% !important;
}
.select_checkbox_column_width_0_2ndcol > div.v-data-table div.v-data-table__wrapper > table > thead th:nth-child(2) {
  width: 0% !important;
}
/*  */
.search-hint-padding div.v-text-field__details {
  padding: 0 3px !important;
  margin-bottom: 0px !important;
}
.signature--pad {
  border: 1px solid #9e9e9e;
}
</style>
